import qs from "qs";
import { createPath, NavigateFunction, parsePath } from "react-router";

/**
 * Adds the params of `search` to a path that may have its own query string. A param in
 * both takes its value from `search`.
 */
export const mergeSearch = (path: string, search: string): string => {
  if (!search) {
    return path;
  }

  const target = parsePath(path);
  const params = new URLSearchParams(target.search);
  const added = new URLSearchParams(search);
  added.forEach((_, key) => params.delete(key));
  added.forEach((value, key) => params.append(key, value));
  const merged = params.toString();

  return createPath({ ...target, search: merged ? `?${merged}` : "" });
};

/**
 * Removes specified query parameters from the current URL
 * @param navigate - React Router navigate function
 * @param currentQuery - Current query object from useQuery()
 * @param paramsToRemove - Array of parameter names to remove
 */
export const removeQueryParams = (
  navigate: NavigateFunction,
  currentQuery: Record<string, any>,
  paramsToRemove: string[]
) => {
  const newQuery = { ...currentQuery };

  paramsToRemove.forEach((param) => {
    delete newQuery[param];
  });

  const newSearch = qs.stringify(newQuery);
  navigate({ search: newSearch }, { replace: true });
};
